import { solicitar } from '../identidad/cliente-identidad.js'
export interface ObservacionInstitucional {
  id: string
  asesorNombre: string
  institucionNombre: string
  asunto: string
  fecha: string
  observacion: string
  audienciaRoles: string[]
  audienciaEstudiantesIds: string[]
  creadoEn: string
}
export interface FiltrosObservacionesInstitucionales {
  institucionId?: string
  asesorUsuarioId?: string
  desde?: string
  hasta?: string
  pagina?: number
  porPagina?: number
}
export interface RespuestaObservacionesInstitucionales {
  datos: ObservacionInstitucional[]
  paginacion: { pagina: number; porPagina: number; total: number; paginas: number }
}
export const listarObservacionesInstitucionales = (
  filtros: FiltrosObservacionesInstitucionales = {},
) => {
  const parametros = new URLSearchParams()
  Object.entries({ porPagina: 20, pagina: 1, ...filtros }).forEach(([clave, valor]) => {
    if (valor !== undefined && valor !== '') parametros.set(clave, String(valor))
  })
  return solicitar<RespuestaObservacionesInstitucionales>(
    `/api/v1/observaciones-institucionales?${parametros.toString()}`,
  )
}
export const crearObservacionInstitucional = (datos: {
  institucionId: string
  asunto: string
  observacion: string
  audienciaRoles: string[]
  audienciaEstudiantesIds: string[]
}) =>
  solicitar<{ id: string }>('/api/v1/observaciones-institucionales', {
    method: 'POST',
    body: JSON.stringify(datos),
  })
